import * as React from "react";
import {StyledQuizCard} from "./StyledQuizCard";
import {Button} from "semantic-ui-react";
import {ActionDisplay} from "./ActionDisplay";
import {Syllabary} from "../../WordFetcher";
import {Action} from "../App";

interface IProps {
    action: Action
    showQuiz(): void,
    currentSyllabary: Syllabary,
    hiraganaCompleted: boolean,
    katakanaCompleted: boolean,
}

interface IState {
}

export class CelebrateCompletion extends React.Component<IProps, IState> {
    public render() {
        if(this.props.action != Action.celebrateCompletion) {
            return '';
        }

        let referenceToOtherLanguage;
        let otherLanguage;
        if(this.props.hiraganaCompleted  && !this.props.katakanaCompleted) {
            otherLanguage = 'katakana'
        } else if(!this.props.hiraganaCompleted  && this.props.katakanaCompleted) {
            otherLanguage = 'hiragana'
        }

        if(otherLanguage == undefined) {
            referenceToOtherLanguage = ''
        } else {
            referenceToOtherLanguage = <p>{'While you have completed ' + this.props.currentSyllabary + ' you still can complete learning ' + otherLanguage + '.'}</p>
        }

        return (
            <StyledQuizCard>
                <p>Congratulations! You have learned all {this.props.currentSyllabary} characters!</p>
                <p>It's recommended to continue regularly practice reading, so that you won't forget everything you just learned</p>
                {referenceToOtherLanguage}
                <ActionDisplay>
                    <Button onClick={() => this.props.showQuiz()}>Let's keep going!</Button>
                </ActionDisplay>
            </StyledQuizCard>
        )
    };
}


// WEBPACK FOOTER //
// ./src/components/QuizBox/CelebrateCompletion.tsx